/* eslint-disable no-unused-vars */
import { createAction } from '@reduxjs/toolkit';
import eventProvider from '../../event/eventProvider';

enum ActionType {
  MQTT_CONNECT_OK = 'MQTT_CONNECT_OK',
  MQTT_CONNECT_LOST = 'MQTT_CONNECT_LOST',
  COCKPIT_TEAM_INFO = 'COCKPIT_TEAM',
  COCKPIT_USER_INFO = 'USER_INFO',
  CHANGE_COCKPIT_MODE_STATUS = 'CHANGE_COCKPIT_MODE_STATUS',
  CLEAR_COCKPIT_INFO = 'CLEAR_COCKPIT_INFO',
}

export const actionCockpitTeamInfo = createAction<any | undefined>(
  ActionType.COCKPIT_TEAM_INFO,
);
export const actionMqttUserInfo = createAction<any | undefined>(
  ActionType.COCKPIT_USER_INFO,
);
export const actionMqttConnectLost = createAction(ActionType.MQTT_CONNECT_LOST);
export const actionMqttConnectOK = createAction(ActionType.MQTT_CONNECT_OK);
export const actionCockpitTeamNumber = createAction<any | undefined>(
  ActionType.CHANGE_COCKPIT_MODE_STATUS,
);
export const actionClearCockpitInfo = createAction(
  ActionType.CLEAR_COCKPIT_INFO,
);

export default ActionType;
